<template>
  <LayoutGridBox :id="`grid-${_id}`" :permalink="permalink" :label="title">
    <LayoutGridBoxImageSection
      class="relative"
      :src="teaser"
      :alt="title"
      :sizes="sizes"
      :grid-sizes="gridSizes"
    >
      <template #fallback>
        <img src="~/assets/logo.svg" :alt="title" />
      </template>
      <template #meta>
        <time
          v-if="!hideTimestamp"
          class="absolute right-0 top-0"
          :datetime="timeUtc"
          >{{ timeAgo }}</time
        >
      </template>
    </LayoutGridBoxImageSection>

    <h3 class="mb-2 font-bold text-category">
      {{ section?.name }}
    </h3>
    <h5 class="mt-auto font-bold">
      {{ title }}
    </h5>
  </LayoutGridBox>
</template>

<script setup lang="ts">
import type { QueryEditorial } from "~/@types/editorial"
import type { GridClass } from "~/@types/feed"

const route = useRoute()
const dayjs = useDayjs()
const props = withDefaults(
  defineProps<{
    post: QueryEditorial
    gridSizes?: GridClass
  }>(),
  {
    gridSizes: () => ({
      sm: true,
      md: true,
    }),
  },
)

const { post } = toRefs(props)

const { _id, title, permalink, teaser, section, publishedAt } = useEditorial(
  post.value,
)
const hideTimestamp = computed(() => route.meta.hideTimestamp)
const { sizes } = useImageInfo(teaser)
const timeUtc = computed(() => dayjs(publishedAt).utc().toString())
const timeAgo = computed(() => dayjs(publishedAt).toNow(true))
</script>
